import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Intro from "./sections/Intro";
import Join from "./sections/Join";
import Company from "./sections/Company";
import Request from "./sections/Request";
import Event from "./sections/Event";
import Partner from "./sections/Partner";
import Head from "../Base/Head";

export default function SISVIP({ event }) {
  const head = {
    title: "SIS 2025 VIP Event Series",
    description:
      "We’re excited to welcome you to Social Innovation Summit 2025 this June in San Francisco gathering 1,000+ bold thinkers and purpose-driven leaders, all committed to building what’s next. As part of your experience, we’re thrilled to extend an exclusive invitation to our VIP event series – a collection of intimate, themed lunches and dinners designed to spark real connection, candid conversation, and meaningful collaboration.",
    url: "https://sisvip.landmarkventures.com",
    image: "https://i.imgur.com/wfcfukI.jpeg",
  };

  return (
    <>
      <Head head={head} />
      <div className="events-wrapper unga-wrapper sisvip-wrapper redesign">
        <Intro event={event} />
        {/* <Join /> */}
        {/* <Event /> */}
        <Request event={event} />
        {/* <Company /> */}
        {/* <Partner /> */}
      </div>
    </>
  );
}
